import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { FBReplyField } from 'components/SocialPreviews';
import Video from 'components/Video/Video';
import * as styles from './FBComment.scss';
import ReactTooltip from 'react-tooltip';
import queryString from 'query-string';
import FBReactionControl from './FBReactionControl';

var FBComment = /*#__PURE__*/function (_Component) {
  _inherits(FBComment, _Component);

  var _super = _createSuper(FBComment);

  function FBComment(props) {
    var _this;

    _classCallCheck(this, FBComment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderReactions", function (reactions, commentId) {
      if (reactions && reactions.length) {
        //      const shorterArray = [...reactions].slice(0, 3);
        var shorterArray = _.uniqBy(reactions, 'details["type"]');

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: styles.reactionInnerWrap,
          "data-tip": true,
          "data-for": "reactionTooltip".concat(commentId)
        }, shorterArray.map(function (reaction, idx) {
          return /*#__PURE__*/React.createElement("img", {
            key: reaction.id,
            style: {
              position: 'relative',
              border: '2px solid #f6f7f9',
              marginRight: -5,
              borderRadius: '100%',
              zIndex: reactions.length * 6 / (idx + 1)
            },
            src: reaction.details && reaction.details.resource ? reaction.details.resource.imageSmall : ''
          });
        }), /*#__PURE__*/React.createElement("small", {
          className: styles.dateText,
          style: {
            fontSize: 11,
            marginLeft: 7
          }
        }, reactions.length)), /*#__PURE__*/React.createElement(ReactTooltip, {
          id: "reactionTooltip".concat(commentId),
          effect: "solid"
        }, reactions.map(function (reaction) {
          return /*#__PURE__*/React.createElement("div", {
            key: reaction.id
          }, /*#__PURE__*/React.createElement("img", {
            src: reaction.details && reaction.details.resource ? reaction.details.resource.imageSmall : ''
          }), /*#__PURE__*/React.createElement("span", {
            style: {
              marginLeft: 2
            }
          }, reaction.details ? reaction.details.name : ''));
        })));
      }

      return null;
    });

    _this.ownerSocialAccount = props.orgSocialAccounts.find(function (sa) {
      return sa.platform === 'Facebook page';
    });
    _this.state = {
      showInputArea: false,
      showReplies: true
    };
    return _this;
  }

  _createClass(FBComment, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          comment = _this$props.comment,
          conversationId = _this$props.conversationId,
          isReply = _this$props.isReply,
          parent = _this$props.parent,
          replies = _this$props.replies;

      var attachmentData = function () {
        var att = comment.details.attachment;

        if (!att) {
          return null;
        }

        switch (att.type) {
          case 'animated_image_share':
            // extract direct gif url from redirect
            return function () {
              var _queryString$parse = queryString.parse("".concat(att.url).split('?')[1]),
                  url = _queryString$parse.u;

              return {
                url: url,
                type: 'gif'
              };
            }();

          case 'video_inline':
            return {
              url: att.media.source,
              type: 'video',
              image: att.media.image ? att.media.image.src : null
            };

          case 'sticker':
            return {
              url: att.media && att.media.image ? att.media.image.src : '',
              type: 'sticker'
            };

          default:
            return {
              url: att.media && att.media.image ? att.media.image.src : '',
              type: 'image'
            };
        }
      }();

      var ownerReactionType = this.ownerSocialAccount && comment.reactions && comment.reactions.find(function (r) {
        return r.details && "".concat(r.details.authorId) === "".concat(_this2.ownerSocialAccount.platformId);
      });
      return /*#__PURE__*/React.createElement("div", {
        id: "comment_".concat(comment.facebookId),
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.comment
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.commentBody
      }, /*#__PURE__*/React.createElement("div", {
        className: isReply ? styles.replyAvatar : styles.commentAvatar,
        style: {
          backgroundImage: "url(".concat(comment.authorAvatarUrl, ")")
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.bodyWrap,
        style: {
          opacity: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.commentOuterWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.commentWrap,
        style: !comment.details.message ? {
          backgroundColor: 'transparent'
        } : this.props.isFocused ? {
          backgroundColor: '#fff9d7'
        } : null
      }, this.props.comment.reactions && this.props.comment.reactions.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.reactionWrap
      }, this.renderReactions(this.props.comment.reactions, this.props.comment.id)), /*#__PURE__*/React.createElement("span", {
        className: styles.commentUserName
      }, comment.authorName, " "), /*#__PURE__*/React.createElement("span", {
        className: styles.commentMessage,
        style: comment.isNew ? {
          fontWeight: 'bold'
        } : {}
      }, comment.details.message)), attachmentData && ['image', 'gif', 'sticker'].includes(attachmentData.type) && /*#__PURE__*/React.createElement("div", {
        className: styles.commentImageWrap,
        style: _objectSpread({}, attachmentData.type === 'sticker' ? {
          border: 'none',
          maxWidth: 80
        } : {})
      }, /*#__PURE__*/React.createElement("img", {
        src: attachmentData.url,
        className: styles.commentImage
      })), attachmentData && ['video'].includes(attachmentData.type) && /*#__PURE__*/React.createElement("div", {
        className: styles.commentImageWrap,
        style: _objectSpread({}, attachmentData.type === 'sticker' ? {
          border: 'none',
          maxWidth: 80
        } : _objectSpread({}, attachmentData.image && !attachmentData.url ? {
          backgroundImage: "url(".concat(attachmentData.image, ")"),
          width: 160,
          height: 120,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        } : {}))
      }, /*#__PURE__*/React.createElement(Video, {
        className: styles.commentImage,
        autoPlay: true,
        loop: true,
        controls: true,
        muted: true,
        src: attachmentData.url
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.likeDateWrap
      }, /*#__PURE__*/React.createElement(FBReactionControl, {
        handleReaction: function handleReaction(type) {
          _this2.props.handleReaction(comment.facebookId, type);
        },
        handleClearReaction: function handleClearReaction() {
          _this2.props.handleClearReaction(comment.facebookId);
        },
        selectedReactionType: ownerReactionType && ownerReactionType.details ? ownerReactionType.details.type : null
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.bullet
      }, "\u2022"), !!this.props.onHandleReply && /*#__PURE__*/React.createElement("span", {
        className: styles.likeBtn,
        onClick: function onClick() {
          _this2.props.onHandleReply(comment);
        }
      }, "Reply"), /*#__PURE__*/React.createElement("span", {
        className: styles.bullet
      }, "\u2022"), /*#__PURE__*/React.createElement("span", {
        className: styles.dateText
      }, moment(comment.details.created_time).fromNow())))), this.state.showInputArea && false && isReply && /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement(FBReplyField, {
        item: comment,
        isReply: true,
        parent: parent,
        conversationId: conversationId,
        closeField: function closeField() {
          return _this2.setState({
            showInputArea: false
          });
        },
        creatingComment: this.props.creatingComment
      }))), replies && /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 8
        }
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this2.setState({
            showReplies: !_this2.state.showReplies
          });
        },
        style: {
          display: 'inline-block',
          margin: '4px 0'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-".concat(this.state.showReplies ? 'down' : 'right'),
        style: {
          cursor: 'pointer'
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.hideReplyText
      }, this.state.showReplies ? 'Hide' : 'Show', " ", replies.length, " repl", replies.length > 1 ? 'ies' : 'y'))), replies && this.state.showReplies && /*#__PURE__*/React.createElement("div", {
        className: styles.repliesWrap
      }, replies, this.state.showInputArea && /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap
      }, /*#__PURE__*/React.createElement(FBReplyField, {
        item: comment,
        isReply: true,
        parent: parent,
        conversationId: conversationId,
        closeField: function closeField() {
          return _this2.setState({
            showInputArea: false
          });
        },
        creatingComment: this.props.creatingComment
      }))));
    }
  }]);

  return FBComment;
}(Component);

export { FBComment as default };